import React, { useEffect } from 'react';
// import ConvertTextToSpeech from '../../customeHooks/convertTextToSpeech';

const SpeechIncorrect = ({
    score,
    fileUrl,
    index,
    correctAnswer,
    selectedAnswer,
}) => {

    // useEffect(() => {
    //     ConvertTextToSpeech({ correctAnswer, elementClass: 'correct-answer-', questionId: index, score });
    // }, [correctAnswer,
    //     index,
    //     score,
    // ])

    return (
        <span> 
            {!!index && <hr/>}
            {correctAnswer === selectedAnswer ? 
              <h4 class="text-success">That's Correct</h4> 
            : <h4 class="text-danger">That's incorrect</h4>}
              <div className="record-container"> 
              
                <p className="quote text-center cloze-selected">{selectedAnswer} </p>

                
                 <div className="audio-player audio-player-wrong">
                    <audio src={fileUrl} controls controlsList="nodownload"></audio>
                    <small>Your answer</small>
                 </div> 
                 { correctAnswer !== selectedAnswer && 
                <div className="audio-player audio-player-correct">
                    <audio src="" controls controlsList="nodownload" id={'correct-answer-'+index}></audio>
                    <small>Check this correct answer</small>
                 </div>}
              </div>
           </span>
    );
}

export default SpeechIncorrect;